import axios from "axios";
const jsonConfig = require("../Config.json");

const getDistinctSMES = async () => {
  return axios.get(jsonConfig.apiUrl + "GetDistinctSME", {
    headers: {
      "x-functions-key": jsonConfig.key,
    },
  });
};

export default getDistinctSMES;
